/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { notification, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import logoImage from '../../../assets/images/logo.png';
import { Link } from "react-router-dom";
import Storage from './../../../services/local-store';
import networkList from './../../../constants/networkList';
import postService from './../../../services/httpService';
import { breaktimeSchema } from './../../../schema/take-a-break';
import Select2 from './../../../components/FormComponent/select2';
import moment from 'moment';
import userTrackService from './../../../services/usertrack-service';
// import menuList from './../../../constants/menu';
import { PropContext } from './../../body/propContext';
import Multiple_units_switch from "../../../common/page/multiple_units_switch";

const {homepage} = networkList;
class Navigation extends Component {
    constructor(props) {
        super(props);
        this.timeoutTime = 0;
        this.state = {
            date: new Date(),
            menuList: [],
            userData: {},
            break_id: null,
            visible: false,
            takeBreak:false,
            break_status:0
        };
        this.logout = this
            .logout
            .bind(this, true);

    }

    showBreak() {


        this.checkBreak();


    }

    selectChanged(data) {

        this.setState((state) => ({ 'break_id': data['value'] }))
    }

    checkBreak() {
        const Userlogobj ={
            "data": {
                "user": localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : "",
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : "",
                    "action": "get User Break Status - Request",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                this.setState({ 'break_status': res['data']['break_status'] });
                if (res['data']['break_status'] === 0) {
                    let { visible } = this.state;
                    breaktimeSchema.feilds.map((data, key) => {
                        breaktimeSchema.feilds[key]['value'] = null;
                        breaktimeSchema.feilds[key]['text'] = 'Select Reason';
                        breaktimeSchema.feilds[key]['errors'] = [];
                    })

                    this.setState((state) => ({ 'breaktimeSchema': breaktimeSchema['feilds'], break_id: null, 'visible': visible ? false : true }));
                }
                let This=this
                if (res['data']['break_status'] === 1) {
                    setTimeout(function () {  
                    This.setState({ 'break_status': 1 });
                    },1000)
                    this.props
                    .history
                    .push(`${homepage}/counselling/start`);
                }
            } else {
                this.setState({ 'break_status': 0 })
            }
        });
    }
    verifyBreak = ()=> {
        const { checkTokenforBreak } = networkList;
        let This= this
        try{
            postService(checkTokenforBreak, 'GET').then(res => {
                console.log(res)
                if (res.status && res.is_patient) {                               
                    Modal.confirm({
                        'title': 'Message',
                        'content': 'You have few more patients waiting from your doctor. Are you sure you want to take a break?',
                        okText: 'Take a Break',
                        cancelText: 'Cancel',
                        onOk: function () {
                            This.showBreak()
                        }
                    })
                } else {
                    this.showBreak()
                }
            })
            } catch (error) {
                console.log(error);
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }
    }
    submitValue() {
        this.setState({loadding: true,takeBreak:true});
        let {id,slug} = this.props.match.params;
        let { break_id, visible, breaktimeSchema } = this.state;
        const { takeAbreakforCounsellor } = networkList;
        let This = this;
        postService('getAssignedTokensforCounseller', 'GET', 'null').then(res => {
            if (res.status) {
                if(res.data.length>0){
                    Modal.warning({
                        'title': 'Success Message',
                        'content': 'Before taking a break, Please complete the assigned token',
                        onOk: function () {
                            This.setState((state) => ({ 'visible': visible ? false : true,loadding:false,break_status:0 }), () => {
                                // This.props
                                //     .history
                                //     .push(`/counselling/start`);
                                if(id === 'counselling' && slug === 'start'){
                                    window.location.reload(true);
                                }

                            });
                        }
                    })
                }
            else{
                if (break_id !== null) {
                    let obj = { "break_reason_id": break_id,break_type:'manual' }
                    postService(takeAbreakforCounsellor, 'POST', { 'data': obj }).then(res => {
                        console.log(res)
                        if (res.status) {
                            setTimeout(function () {  
                         This.setState({break_status:1});
                         postService('getBreaktimeReasons', 'GET', 'null').then(ress => {
                            if(ress.status){
                                Storage.store('all_BreakTimeReasons',ress.data);
                            }
                         })
        
                        }, 1000);
                        if(res.data==1){
                            Modal.warning({
                                'title': 'Success Message',
                                'content':res.message?res.message:'Oops, something went wrong... Please try again.',
                                onOk: function () {
                                    This.setState((state) => ({ 'visible': visible ? false : true,loadding:false,break_status:0 }), () => {
                                        // This.props
                                        //     .history
                                        //     .push(`/counselling/start`);
                                        if(id === 'counselling' && slug === 'start'){
                                            window.location.reload(true);
                                        }
        
                                    });
                                }
                            })
                        }else{
                            Storage.store('break_status',1);
                            Modal.success({
                                'title': 'Success Message',
                                'content': id ==='counselling' && slug === 'start'?'Take a break':'Take a break, after this transaction',
                                onOk: function () {
                                    This.setState((state) => ({ 'visible': visible ? false : true,loadding:false,break_status:0 }), () => {
                                        // This.props
                                        //     .history
                                        //     .push(`/counselling/start`);
                                        if(id === 'counselling' && slug === 'start'){
                                            window.location.reload(true);
                                        }
        
                                    });
                                }
                            })
                        }
                         
                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops, something went wrong... Please try again.",
                            });
                        }
                    })
        
                } else {
                    breaktimeSchema.map((data, key) => {
                        breaktimeSchema[key]['errors'] = [{ 'message': 'Please select reason' }];
                    })
                    this.setState((state) => ({ 'breaktimeSchema': breaktimeSchema }))
                }
            }
         }
        });
        
    }

    componentDidMount() {
        let userData = localStorage.getItem('user_data');
        if (userData && userData !== null) {
            userData = JSON.parse(userData);
            this.setState((state) => ({ 'userData': userData }))
        }
        console.log(this.props);
        this.fetchMenu();
        // this.setup();
       if(userData && userData['roleid'] && userData['roleid'] === 'RL_HjPW'){
        this.checkBreakforcounsellor();
       }
    }
    showProfile = () => {
        this
            .props
            .history
            .push(`/profile`);
    }
    fetchMenu() {
        const { getRolePermissions } = networkList;
        postService(getRolePermissions, 'GET', null).then(res => {
            console.log(res)
            if (res.status) {
                this.props.menuData(res.data);
                this.setState((state) => ({ menuList: res.data }));
            }
        })
    }
    clearAll() {
        Storage.clearAll();
        this
            .props
            .history
            .push(`/`);
    }





    setup() {
        const { id, slug } = this.props.match.params;

        if ((id !== 'tv-display' && id !== 'nurse-display' && id!== 'new-nurse-display' &&  id !== 'nurse-stations' && id !== 'digital-signature' ) && id !== '' && id !== '/') {
            window.addEventListener("mousemove", () => this.resetTimer(), false);
            window.addEventListener("mousedown", () => this.resetTimer(), false);
            window.addEventListener("keypress", () => this.resetTimer(), false);
            window.addEventListener("DOMMouseScroll", () => this.resetTimer(), false);
            window.addEventListener("mousewheel", () => this.resetTimer(), false);
            window.addEventListener("touchmove", () => this.resetTimer(), false);
            window.addEventListener("MSPointerMove", () => this.resetTimer(), false);
            this.startTimer();
        }

    }

    startTimer() {
        this.timeoutTime = moment();
        // console.log('timmer Start', moment().format('HH:mm s'));
        this.timeoutID = window.setInterval(() => this.goInactive(), 60000);
    }

    resetTimer(e) {
        // console.log('timmer reset', moment().format('HH:mm s'));
        this.timeoutTime = 0;
        window.clearInterval(this.timeoutID);
        this.goActive();
    }

    goInactive() {
        let timeDiff = moment.duration(moment().diff(this.timeoutTime)).minutes();

        // console.log('timmer inactive', timeDiff);
        let This = this;
        if (timeDiff === 56) {
            Modal.destroyAll();
            Modal.confirm({
                title: 'Inactive Session. Your session is no longer active',
                icon: <ExclamationCircleOutlined />,
                content: `You will Auto Logout in next 3min`,
                okText: 'Stay signed in',
                okType: 'primary',
                cancelText: 'Logout',
                cancelType: 'danger',
                onOk() {
                    This.resetTimer();
                },
                onCancel() {
                    window.clearTimeout(This.timeoutID);
                    This.logout();
                },
            });
        }

        if (timeDiff === 59) {
            Modal.destroyAll();
            // console.log('timmer inactive', timeDiff);
            window.clearTimeout(this.timeoutID);
            this.logout();
        }
    }

    goActive() {
        this.startTimer();
    }

    // logout = () => {
    //     const { logout } = networkList;
    //     const id = JSON.parse(Storage.get('id'));
    //     Modal.destroyAll();
    //     // let data={
    //     //     "id": id,               
    //     // }
    //     // console.log('data', data)
    //     this.setState({
    //         "id": id,
    //     })
    //    const breakStatus= JSON.parse(Storage.get('break_status'));
    //     if( breakStatus==0 || breakStatus==null){
    //         try {
    //             this.setState((state) => ({ btnloading: true }), () => {
    //                 postService(logout, 'GET', {
    //                     "id": this.state.id,
    //                 }).then(res => {
    //                     if (res.status) {
    //                         // alert('Data inserted');
    //                         // console.log('res', res)
    //                         // this.setState((state) => ({ btnloading: false, visible: false }));
    //                         // Modal.success({
    //                         //     title: 'Success',
    //                         //     content: "Successfully Updated",
    //                         // });
    //                         // notification.success({
    //                         //     message: 'Success',
    //                         //     description: res.message,
    //                         //     duration: 3,
    //                         //     top: 20,
    //                         //     right: 0
    //                         // });
    //                     } else {
    //                         // alert('Data not inserted');
    //                         // this.setState({btnloading:false})
    //                         // Modal.error({
    //                         //     title: 'Failure',
    //                         //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
    //                         // });
    //                         // notification.error({
    //                         //     message: 'Failure',
    //                         //     description: res.message? res.message:'Oops! something went wrong... Please try again.',
    //                         //     duration: 3,
    //                         //     top: 20,
    //                         //     right: 0
    //                         // });
    //                     }
    //                     this.clearAll()
    //                 })
    //             });
    //         } catch (error) {
    //             console.log(error);
    //             Modal.error({
    //                 title: 'Failure',
    //                 content: "Oops, something went wrong... Please try again.",
    //             });
    //         }
    //     }else{
    //         Modal.warning({
    //             title: 'Warning',
    //             content: 'Please stop the break before logout.',
    //         }); 
    //     }
       

    // }

    logout = () => {
        const { logout } = networkList;
        const id = JSON.parse(Storage.get('id'));
        Modal.destroyAll();
      
        this.setState({
          id: id,
        });
      
        const breakStatus = JSON.parse(Storage.get('break_status'));
        if (breakStatus == 0 || breakStatus == null) {
          try {
            this.setState((state) => ({ btnloading: true }), () => {
              postService(logout, 'GET', {
                id: this.state.id,
              }).then(res => {
                console.log("Counsellor Logged Out");
                if (res.status) {
                  // alert('Data inserted');
                  // console.log('res', res)
                  // this.setState((state) => ({ btnloading: false, visible: false }));
                  // Modal.success({
                  //     title: 'Success',
                  //     content: "Successfully Updated",
                  // });
                  // notification.success({
                  //     message: 'Success',
                  //     description: res.message,
                  //     duration: 3,
                  //     top: 20,
                  //     right: 0
                  // });
                  this.clearAll();
                } else {
                    Modal.warning({
                        title: 'Warning',
                        content: res.message || 'You are unable to perform the logout operation as it is restricted until at least 8 hours have elapsed since your last login',
                      });
                  // alert('Data not inserted');
                  // this.setState({btnloading:false})
                  // Modal.error({
                  //     title: 'Failure',
                  //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
                  // });
                  // notification.error({
                  //     message: 'Failure',
                  //     description: res.message? res.message:'Oops! something went wrong... Please try again.',
                  //     duration: 3,
                  //     top: 20,
                  //     right: 0
                  // });
                }
              });
            });
          } catch (error) {
            console.log(error);
            Modal.error({
              title: 'Failure',
              content: "Oops, something went wrong... Please try again.",
            });
          }
        } else {
          Modal.warning({
            title: 'Warning',
            content: 'Please stop the break before logout.',
          });
        }
      }
      
    checkBreakforcounsellor() {
        const Userlogobj ={
            "data": {
                "user": localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : "",
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : "",
                    "action": "get User Break Status - Request",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            let This=this
            if (res.status) {
                This.setState({ 'break_status': res['data']['break_status'] });
               
               
                if (res['data']['break_status'] === 1) {
                    setTimeout(function () {  
                    This.setState({ 'break_status': 1 });
                    },1000)
                   
                }
            } else {
                setTimeout(function () {  
                    This.setState({ 'break_status': 0 });
                    },1000)
                this.setState({ 'break_status': 0 })
            }
        });
    }
    render() {
        let { id, slug } = this.props.match.params;
        const { menuList, userData, breaktimeSchema,break_status,takeBreak } = this.state;
        const setHref = str => (window.location.href = str);
        const currenthref = window.location.pathname;
        menuList.sort(function (a, b) {
            return (a.menu_order - b.menu_order);
        });
        let user_data
        if (localStorage.getItem('user_data') && localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        if(user_data===undefined){
            if(id === "digital-signature"){
                user_data = "UN1"
            }else {
                let url=window.location.href;
                url=url.split("=");
                user_data=url[1];
                if(user_data.length>4){ // tv-dispaly
                  const  unit= user_data.split("C");
                  user_data=unit[0]
                }
            }
        }
       
        console.log("test the refresh... navigation: " + currenthref);
        // console.log("test the refresh... slug" + slug);
        // console.log("test the refresh... id" + id);
        return (
            <PropContext.Provider value={{ menuList: this.state.menuList }}>                
                {( slug !== 'view-document') && <React.Fragment>
                <header id="navbar">
                    <div className="container-fluid d-print-none pl-5 pr-5 " style={{height:currenthref !== `${homepage}/nurse-display`? currenthref === `${homepage}/nurse-stations`? 'px': currenthref === `${homepage}/new-nurse-display`? '60px': '80px': '0px'}}>
                        <div className="row">
                            <div className="col-6 col-lg-1">
                                <div className="logo my-2">
                                    {user_data["unitid"]&&user_data["unitid"]==='UN1'|| user_data["unitid"]==='UN2'?<img src={`${logoImage}`}/>:user_data&& user_data=="UN1" || user_data=="UN2"?<img src={`${logoImage}`}/> : <img src={homepage+`/assets/images/units-logo/${user_data["unitid"]?user_data["unitid"]+'.png':user_data+'.png'}`} alt="Logo" className="w-100 h-100" />}
                                    <div className='row mt-2' style={{position: 'fixed', top: '40px', left: '20px', zIndex: 4, width: '16%', transform: 'scale(0.6)'}}>
                    <Multiple_units_switch {...this.state} {...this.props} />
                </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-11 text-right mt-2">
                                <div className="menu-List">
                                    {((id === undefined || id !== undefined) && (id !== 'tv-display' && id !== 'nurse-display' && id !== 'nurse-stations' && id !== 'digital-signature' )) &&
                                        <ul className="list-inline">

                                            {menuList.map((menu, key) => {
                                                if (menu.submenu.length === 0) {
                                                    if (menu.permissions['view'] === 'true') {
                                                        return (
                                                            <li className="list-inline-item mr-0" key={key}>
                                                                <Link to={`/${menu.route}`}><img src={homepage+`/assets/images/icons/${menu.icon}`} alt="" />{menu.text}</Link>
                                                            </li>
                                                        )
                                                    }
                                                }
                                                if (menu.submenu.length !== 0) {
                                                    return (
                                                        <li className="list-inline-item mr-0 dropdown" key={key}>
                                                            <a
                                                                className="dropdown-toggle"
                                                                href="javascript:void(0);"
                                                                role="button"
                                                                id={`dropdownMenuLink${key}`}
                                                                data-toggle="dropdown"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"><img src={homepage+`/assets/images/icons/${menu.icon}`} alt="" />{menu.text}</a>
                                                            <div className="dropdown-menu" aria-labelledby={`dropdownMenuLink${key}`}>
                                                                {menu
                                                                    .submenu
                                                                    .map((submenu, skey) => {
                                                                        if (submenu.permissions['view'] === 'true') {
                                                                            return (

                                                                                <Link
                                                                                    key={skey}
                                                                                    className="dropdown-item"
                                                                                    to={`/${menu.route}/${submenu.route}`}>{submenu.text}</Link>

                                                                            )
                                                                        }
                                                                    })}

                                                            </div>
                                                        </li>
                                                    )
                                                }
                                            })}


                                            <li className="list-inline-item">
                                                <a
                                                    href="javascript:void(0)"
                                                    className="dropdown-toggle"
                                                    role="button"
                                                    id="dropdownMenuLink3"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false">{JSON.parse(Storage.get('user'))}  <img
                                                        src={homepage+"/assets/images/icons/user-avatar@3x.png"}
                                                        alt="KIMS FC Settings Icon" /><small className="nav-info">({JSON.parse(Storage.get('role'))})</small></a>
                                                <div className="dropdown-menu" aria-labelledby="dropdownMenuLink3">
                                                    <a href="javascript:void(0)" className="dropdown-item" onClick={this.showProfile}>Profile</a>
                                                    {(userData && userData['roleid'] && userData['roleid'] === 'RL_HjPW') &&
                                                        <a href="javascript:void(0)" className="dropdown-item" onClick={()=>{this.verifyBreak()}}>Take a Break</a>}
                                                    <a href="javascript:void(0)" className="dropdown-item" onClick={this.logout}>Logout</a>
                                                </div>
                                            </li>


                                        </ul>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal visible={this.state.visible} onCancel={this.showBreak.bind(this)} footer={null}>
                        <div className="token-popup p-5">
                            <h3>Are your sure you want to go on break time?</h3>
                            {(breaktimeSchema !== undefined) && <React.Fragment>
                                {breaktimeSchema
                                    .map((feild, key) => {

                                        if (feild.element === 'select2') {
                                            return (
                                                <div class="col-12 pt-4 mb-2">
                                                    <Select2

                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={this
                                                            .selectChanged
                                                            .bind(this)}
                                                    /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}

                                                </div>
                                            )
                                        }
                                    })}
                            </React.Fragment>}
                            <div className="row justify-content-center pt-4">
                                <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.submitValue.bind(this)} disabled={this.state.takeBreak}>submit</button>
                                <button className="btn btn-success text-capitalize" onClick={this.showBreak.bind(this)}>Cancel</button>
                            </div>
                        </div>
                    </Modal>
               
                    <Modal visible={this.state.visible} onCancel={this.showBreak.bind(this)} footer={null}>
                        <div className="token-popup p-5">
                            <h3>Are your sure you want to go on break time?</h3>
                            {(breaktimeSchema !== undefined) && <React.Fragment>
                                {breaktimeSchema
                                    .map((feild, key) => {

                                        if (feild.element === 'select2') {
                                            return (
                                                <div class="col-12 pt-4 mb-2">
                                                    <Select2

                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={this
                                                            .selectChanged
                                                            .bind(this)}
                                                    /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}

                                                </div>
                                            )
                                        }
                                    })}
                            </React.Fragment>}
                            <div className="row justify-content-center pt-4">
                                <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.submitValue.bind(this)}>submit</button>
                                <button className="btn btn-success text-capitalize" onClick={this.showBreak.bind(this)}>Cancel</button>
                            </div>
                        </div>
                    </Modal>
                </header>
                </React.Fragment>}
            </PropContext.Provider>
        );
    }
}

export default Navigation;
